/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AchievementIcon = /*#__PURE__*/ createSvgIcon(
  'AchievementIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M7.104 10.792l1.354.854 1.23-.584A.702.702 0 0110 10.98c.097 0 .201.028.313.084l1.229.583 1.354-.875L12.042 9H7.958l-.854 1.792zM4.375 16.5h11.25l-2.063-4.354-1.562.979a.846.846 0 01-.365.125.646.646 0 01-.364-.063L10 12.584l-1.292.604a.692.692 0 01-.354.073.735.735 0 01-.354-.114l-1.562-.98L4.375 16.5zM3.188 18a.684.684 0 01-.625-.344.736.736 0 01-.042-.718l4.062-8.584a1.46 1.46 0 01.552-.625c.243-.153.51-.229.803-.229H9.25V2.75c0-.208.073-.385.219-.531A.723.723 0 0110 2h3.292a.35.35 0 01.333.198c.07.132.063.26-.02.385l-.46.709a.402.402 0 00-.062.208c0 .07.021.139.063.208l.458.709c.084.125.09.253.021.385a.35.35 0 01-.333.198H10.75v2.5h1.313c.291 0 .558.076.802.23.243.152.427.36.552.624l4.062 8.584c.111.25.097.49-.041.718a.684.684 0 01-.625.344H3.188z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default AchievementIcon;
